/*
 * Copyright (c) 2017-2024. Code réalisé par IpsoSenso.
 */

import Grid from '@material-ui/core/Grid'
import React, { Fragment } from 'react'
import UsersManagement from './components/UsersManagement'

const UsersPage = () => (
	<Fragment>
		<Grid container>
			<Grid item xs={12}>
				<UsersManagement />
			</Grid>
		</Grid>
	</Fragment>
)

export default UsersPage
